import { render, staticRenderFns } from "./winloseTable.vue?vue&type=template&id=18c95fee&scoped=true&"
import script from "./winloseTable.vue?vue&type=script&lang=js&"
export * from "./winloseTable.vue?vue&type=script&lang=js&"
import style0 from "./winloseTable.vue?vue&type=style&index=0&id=18c95fee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c95fee",
  null
  
)

export default component.exports